
export default {
  name: 'side-by-side-block',
  props: ['information'],
  components: {},
  data() {
    return {}
  },
  methods: {}
}